module.exports = __webpack_public_path__ + "img/gsb33.8330e5c4.png";